import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const usePharmacyStore = create(
	persist(
		(set) => ({
			pharmacyLocations: [],
			selectedPharmacy: null,
			platform: null,
			locations: [],
			ecosystem: null,
			isNewFile: {
				isNewFile: null,
				id: null,
			},
			setPharmacyLocations: (newPharmacy) => set({ pharmacyLocations: newPharmacy }),
			setSelectedPharmacy: (pharmacy) => set({ selectedPharmacy: pharmacy }),
			setLocations: (newLocations) => set({ locations: newLocations }),
			setIsNewFile: (enable) => set({ isNewFile: enable }),
			setEcosystem: (ecosystem) => set({ ecosystem: ecosystem }),
			setPlatform: (platform) => set({ platform: platform }),
		}),
		{
			name: 'pharmacy-storage',
			getStorage: () => sessionStorage,
		},
	),
);

export default usePharmacyStore;
